import React, {useState, useContext, useEffect} from "react";
import {makeStyles} from "@mui/styles"
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import {LoadingContext} from "@hoc/loading";
import {ErrorMessageContext} from "@hoc/errorMessage";
import {renderForm, updateInfo} from "@components/Form/renderForm";
import {add} from '@api/subsciption_plus_access';
import {validation} from "@services/validation";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from '@mui/material/Grid';
import Typography from "@mui/material/Typography";
import {red} from '@mui/material/colors';
import {styled} from '@mui/material/styles';
import {Activate} from '@components/Activate';
import 'react-phone-number-input/style.css'


const ColorButton = styled(Button)(({theme}) => ({
    fontSize: 32,
    backgroundColor: red[500],
    '&:hover': {
        backgroundColor: red[700],
    },
}));

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    pagination: {
        textAlign: 'center',
    },
    label: {
        fontSize: '2rem',
    },
    link: {
        textDecoration: 'underline',
        color: '#d72821'
    },
    sucessMsg: {
        textAlign: 'center',
    },
    paginationButton: {
        margin: '5px',
    },
    submitBlock: {
        textAlign: 'center',
    },
    register: {
        justifyContent: 'center',
        minHeight: '200px',
    }
});

export const SubscriptionPlusAccessForm = () => {
        const classes = useStyles();
        const {loading, setLoading} = useContext(LoadingContext);
        const {errorMessage, setErrorMessage} = useContext(ErrorMessageContext);
        const [register, setRegister] = useState(false);
        const [currentTab, setCurrentTab] = useState(0);
        const [validatePagination, setValidatePagination] = useState(true);
        const [form, setForm] = useState({});
        const [code, setCode] = useState(null);

        const onCallback = (e) => {
            updateOnCallback(e, columnData);
        }

        const updateOnCallback = (e, data) => {
            data.forEach((column) => {
                column.data.forEach((column) => {
                    if (column.name === e.target.name) {
                        let value = e.target.value;
                        if (column.type === 'select') {
                            if (!column.value.includes(value)) {
                                column.value.push(value);
                                value = column.value;
                            }
                        }
                        if (column.type === 'checkbox') {
                            if (!column.value.includes(value)) {
                                column.value.push(value);
                                value = column.value;
                            } else {
                                value = column.value.filter((list) => list !== value);
                            }
                        }
                        column.value = value;
                        column.error = '';
                    }
                })
                column.setFunc([...column.data]);
            })
        }

        const contactInformationData = [{
            name: 'full_name',
            headerName: 'Full Name',
            inputProps: {required: true},
            value: '',
            type: 'string',
            onCallback: onCallback,
        }, {
            name: 'company_name',
            headerName: 'Company Name',
            type: 'string',
            inputProps: {required: true},
            value: '',
            onCallback: onCallback,
        }, {
            name: 'email',
            headerName: 'Email',
            type: 'string',
            value: '',
            inputProps: {required: true, type: 'email'},
            onCallback: onCallback,
        }, {
            name: 'phone',
            headerName: 'Phone Number',
            inputProps: {required: true},
            type: 'phone',
            value: '',
            onCallback: onCallback,
        }];

        const [columnsContactInformation, setColumnsContactInformation] = useState(contactInformationData);
        const columnData = [
            {data: columnsContactInformation, setFunc: setColumnsContactInformation},
        ]

        const handleSubmit = async (event) => {
            event.preventDefault();

            if (!validateColumn(currentTab + 1)) return;

            setLoading(true);
            setErrorMessage(null);

            try {
                const data = new FormData(event.target);
                let obj = updateInfo([...columnsContactInformation], data);
                setForm(obj)
                obj.type = 'subsciption_plus_access';

                const docRef = await add(obj);
                setLoading(false);

                if (docRef.data.error) {
                    return alert(docRef.data.error)
                }
                if (docRef.data.code) {
                    setCode(docRef.data.code);
                }
                setRegister(true);
            } catch (e) {
                validateData(e, columnData);
                setErrorMessage(e);
                setLoading(false);
            }
        }

        const validateData = (e, data) => {
            data.forEach((column) => {
                validation(e, column.data, (columnUpdate) => {
                    return column.setFunc([...columnUpdate]);
                })
            })
        }

        const columnsEl = [{
                label: 'For organisations with 50 users or more, you may qualify for a free subscription plan in addition to various other discounts and benefits. Please submit your details below and we’ll get straight back to you to discuss further.',
                data: columnsContactInformation,
            }]

        const validateEmail = (email) => {
            return String(email)
                .toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
        };

        const validateColumn = (ind) => {
            const currentTab = columnData[ind - 1];
            let validatePaginationData = true;
            currentTab.data.forEach((val) => {

                if (!val?.classList?.match('hidden') && val?.inputProps?.type === 'email' && val.value && validateEmail(val.value) === null) {
                    validatePaginationData = false;
                    val.error = 'validate email';
                }

                if (!val?.classList?.match('hidden') && val?.inputProps?.required &&
                    (!val.value || (typeof val.value === 'object' && !val.value.length && !(val.value instanceof Date)) || (typeof val.value === 'number' && !val.value))) {
                    validatePaginationData = false;
                    val.error = 'is required field';
                }
            })

            columnData[ind - 1].setFunc([...currentTab.data]);

            return validatePaginationData;
        }

        useEffect(() => {
            if (window?.parent?.document?.querySelector(".professional_photography_network_booking iframe")) {
                window.parent.document.querySelector(".professional_photography_network_booking iframe").scrollIntoView();
            }
        }, [currentTab])


        return (<div style={{marginTop: '50px'}}>
                {register ? <Box className={classes.sucessMsg}><Typography variant={'h3'}>Thank you very much for your interest in EyeSpy360, a member of our operations team will be in touch very shortly and if you need anything in the meantime please feel free to <a className={classes.link} href="https://www.eyespy360.com/en-gb/#footer-widget-section"> contact us</a>.</Typography></Box> : <></>}
                <Container maxWidth={'md'}
                           component="form"
                           className={register ? 'hidden' : ''}
                           noValidate
                           onSubmit={handleSubmit}>
                    {columnsEl.map((column, ind) => (
                        <Grid xs={12} key={ind} item className={currentTab === ind ? '' : 'hidden'}
                              container
                              justifyContent="start"
                              alignItems="center"
                              spacing={3}>
                            <Grid xs={12} item><Typography className={classes.label} variant="h4" gutterBottom>{column.label}</Typography>
                                <hr/>
                            </Grid>
                            {
                                column.data.map((data, key) => (
                                    renderForm(data, key)
                                ))
                            }
                            <Grid item
                                  style={{textAling: 'left'}}
                                  xs={12}
                            >
                                <Typography variant="caption">*Mandatory</Typography>
                            </Grid>
                            <Grid item
                                  className={currentTab == columnsEl.length - 1 ? classes.submitBlock : 'hidden'}
                                  xs={12}
                            >
                                <ColorButton
                                    type="submit"
                                    variant="contained"
                                >
                                    submit
                                </ColorButton>
                            </Grid>
                        </Grid>
                    ))}
                </Container>

            </div>
        );
    }
;